export default {"src":"/_next/static/media/HKFlag.15087683.svg","height":18,"width":24};